import React from "react";
import * as styles from "./ItemList.module.scss";

export interface ItemListBoxProps {
  Item: React.FC;
}

const ItemListItem: React.FC = ({ children }) => {
  return <li className={styles.item}>{children}</li>;
};

const ItemList: React.FC & ItemListBoxProps = ({ children }) => {
  return <ul className={styles.inlineList}>{children}</ul>;
};

ItemList.Item = ItemListItem;

export default ItemList;
